import { render, staticRenderFns } from "./Canceled.vue?vue&type=template&id=8e63f2ac&scoped=true&lang=pug&"
import script from "./Canceled.vue?vue&type=script&lang=js&"
export * from "./Canceled.vue?vue&type=script&lang=js&"
import style0 from "./Canceled.vue?vue&type=style&index=0&id=8e63f2ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e63f2ac",
  null
  
)

export default component.exports